
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_ERROR = 'SHOW_ERROR';
export const SHOW_WARNING = 'SHOW_WARNING';
export const SHOW_INFO = 'SHOW_INFO';
export const SHOW_INFO_AUTH = 'SHOW_INFO_AUTH';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

const initialState = {
  message: '',
  type: '',
};

export default  function messageReducer(state = initialState, action:any) {
    switch (action.type) {
      case SHOW_SUCCESS:
        return { message: action.payload, type: 'success' };
      case SHOW_ERROR:
        return { message: action.payload, type: 'error' };
      case SHOW_INFO_AUTH:
        return { message: action.payload, type: 'error_auth' };
      case SHOW_WARNING:
        return { message: action.payload, type: 'warning' };
      case SHOW_INFO:
        return { message: action.payload, type: 'info' };
      case HIDE_MESSAGE:
        return initialState;
      default:
        return state;
    }
  }